export class AllocatedBalance {
    public allocatedBalanceId: number;
    public balance: number;
    public costCenterId: number;
    public costCenter: string;
    public name: string;
    public principalProduct: string;
    public products: ProductAllocated[];
}

export class ProductAllocated {
    allocatedBalanceAssociationId: 2;
    isPrincipal: boolean;
    productId: number;
    productName: string;
}

export class CreateAllocatedBalance {
    allocatedBalanceId: number;
    assignorGuid: string;
    name: string;
    costCenterId: number;
    principalProductId: number;
    products: number[] = [];
}

export class DepositBalance {
    public accountId: number;
    public balance: number;
}

export class TransferAllocatedBalanceRequest {
    assignorGuid: string;
    allocatedBalanceId: number;
    isCurrentAccount: boolean = true;
    allocatedBalanceDebitId: number = 0;
    value: number;
    managerId: number;
}

export class WithdrawAllocatedBalanceRequest {
    assignorGuid: string;
    allocatedBalanceId: number;
    value: number;
    managerId: number;
}